<template>
  <div>
    <div class="suggestion-list mentionSuggestion" ref="suggestions">
      <v-card
        v-show="openMentionMenu"
        tile
        max-height="200"
        class="overflow-y-auto mx-auto mention-users"
        ref="mentionChannelContainer"
      >
        <v-list
          v-show="hasResults"
          class="pointer overflow-scroll"
          scrollable
          max-height="150"
        >
          <v-list-item
            v-for="(user, index) in members"
            :key="index"
            class="d-flex caption overflow-scroll pointer"
            ref="searchFocus"
            :input-value="index == focusMember"
            :class="index == focusMember ? 'bg-selected' : ''"
            @click="selectUser(user.id, user.name ? user.name : user.email)"
            @keydown.enter="
              selectUser(user.id, user.name ? user.name : user.email)
            "
          >
            <ProfileImage
              v-show="user.image ? ':src' : ':username'"
              :src="user.image"
              inline
              :username="user.name ? user.name : user.email"
              :size="23"
              :userProfile="true"
              :circular="true"
              class="ml-3 text-light"
            ></ProfileImage>

            <div
              style="max-width: 180px;"
              class="d-inline-block text-truncate ml-2"
              :class="user.name ? 'text-capitalize' : ''"
            >
              {{ user.name ? user.name : user.email }}
            </div>
          </v-list-item>
        </v-list>
      </v-card>
    </div>
    <!-- Write Comment Field -->
    <div
      id="editor-input-div"
      class="editor"
      :style="$vuetify.breakpoint.xs ? 'width:70%;' : 'width: 345px;'"
    >
      <editor-content
        autofocus
        id="editor"
        class="editor__content ml-4 edited_scrollbar"
        :editor="editor"
      />
    </div>
    <!-- Editor Menu Bar -->
    <editor-menu-bar
      :editor="editor"
      v-slot="{ commands, isActive }"
      v-show="showMenuBar"
    >
      <div class="menubar">
        <v-tooltip
          :disabled="$vuetify.breakpoint.xs"
          top
          color="#DCD8F3"
          content-class="arrow-down"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              class="menubar__button"
              :class="{ 'is-active': isActive.bold() }"
              @click="commands.bold"
            >
              <v-icon size="18px" color="rgb(96,96,96)" medium>
                mdi-format-bold
              </v-icon>
            </v-btn>
          </template>
          <span class="font-weight-bold dark-purple-text">Bold</span>
        </v-tooltip>

        <v-tooltip
          :disabled="$vuetify.breakpoint.xs"
          top
          color="#DCD8F3"
          content-class="arrow-down"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              icon
              class="menubar__button"
              :class="{ 'is-active': isActive.italic() }"
              @click="commands.italic"
            >
              <v-icon size="18px" color="rgb(96,96,96)" medium>
                mdi-format-italic
              </v-icon>
            </v-btn>
          </template>
          <span class="font-weight-bold dark-purple-text">Italic</span>
        </v-tooltip>

        <v-tooltip
          :disabled="$vuetify.breakpoint.xs"
          top
          color="#DCD8F3"
          content-class="arrow-down"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              icon
              class="menubar__button"
              :class="{ 'is-active': isActive.underline() }"
              @click="commands.underline"
            >
              <v-icon size="18px" color="rgb(96,96,96)" medium>
                mdi-format-underline
              </v-icon>
            </v-btn>
          </template>
          <span class="font-weight-bold dark-purple-text">Under Line</span>
        </v-tooltip>
        <v-tooltip
          color="#DCD8F3"
          content-class="arrow-down"
          :disabled="$vuetify.breakpoint.xs"
          top
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              icon
              class="menubar__button"
              :class="{ 'is-active': isActive.code_block() }"
              @click="commands.code_block"
            >
              <v-icon size="18px" color="rgb(96,96,96)" medium>
                mdi-iframe-braces-outline
              </v-icon>
            </v-btn>
          </template>
          <span class="dark-purple-text font-weight-bold">Code</span>
        </v-tooltip>
        <v-tooltip
          :disabled="$vuetify.breakpoint.xs"
          top
          color="#DCD8F3"
          content-class="arrow-down"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              icon
              class="menubar__button"
              :class="{ 'is-active': isActive.bullet_list() }"
              @click="commands.bullet_list"
            >
              <v-icon size="18px" color="rgb(96,96,96)" medium>
                mdi-format-list-bulleted
              </v-icon>
            </v-btn>
          </template>
          <span class="dark-purple-text font-weight-bold">Unorder List</span>
        </v-tooltip>

        <v-tooltip
          :disabled="$vuetify.breakpoint.xs"
          top
          color="#DCD8F3"
          content-class="arrow-down"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              icon
              class="menubar__button"
              :class="{ 'is-active': isActive.ordered_list() }"
              @click="commands.ordered_list"
            >
              <v-icon size="18px" color="rgb(96,96,96)">
                mdi-format-list-numbered
              </v-icon>
            </v-btn>
          </template>
          <span class="dark-purple-text font-weight-bold">Order List</span>
        </v-tooltip>

        <span class="float-right">
          <v-tooltip
            :disabled="$vuetify.breakpoint.xs"
            top
            color="#DCD8F3"
            content-class="arrow-down"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                icon
                class="menubar__button mx-1"
                @click="
                  getSelectedCompany.subscribed_plan &&
                  getSelectedCompany.subscribed_plan.toLowerCase() != 'basic'
                    ? openScheduleMessageDialog()
                    : dispayErrorMessage()
                "
              >
                <img
                  class="w-input-icon-send"
                  src="@/assets/svgs/schedule-message.svg"
                  alt="schedule"
                  style="max-height: 16px; max-width: 16px"
                />
              </v-btn>
            </template>
            <span class="dark-purple-text font-weight-bold">Schedule Send</span>
          </v-tooltip>
          <!-- send button -->
          <v-btn
            @click="sendTextMessage"
            class="text-capitalize white--text  mt-1 mr-1 btn-success"
            depressed
            :disabled="
              showAudio && !getAudioRecord
                ? true
                : false || getScreenRecorderState
            "
            :small="!$vuetify.breakpoint.xs"
            :x-small="$vuetify.breakpoint.xs"
          >
            Send
          </v-btn>
        </span>
      </div>
    </editor-menu-bar>

    <ScheduleMessage
      v-if="
        getSelectedCompany.subscribed_plan &&
          getSelectedCompany.subscribed_plan.toLowerCase() != 'basic'
      "
    />
  </div>
</template>
<script>
import Fuse from "fuse.js";
import { Editor, EditorContent, EditorMenuBar } from "tiptap";
import { eventBus } from "@/main";
import { mapGetters } from "vuex";
import SendMessage from "@/TipTapExtension/sendMessage";
import CustomLink from "@/TipTapExtension/customLink";
import Swal from "sweetalert2";

import {
  Blockquote,
  CodeBlock,
  Code,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  ListItem,
  BulletList,
  Bold,
  Italic,
  Underline,
  History,
  Mention,
  Placeholder,
} from "tiptap-extensions";
export default {
  components: {
    EditorContent,
    EditorMenuBar,
    ProfileImage: () => import("@/components/Includes/ProfileImage"),
    ScheduleMessage: () =>
      import("@/components/Tasks/Comments/ScheduleMessageDialog"),
  },
  props: ["displayMenuBar", "showAudio", "getAudioRecord", "taskDetails"],
  data() {
    return {
      selectedUser: null,
      selectedId: null,
      query: null,
      suggestionRange: null,
      full_comment: "",
      focusMember: 0,
      members: [],
      showMenuBar: false,
      openMentionMenu: false,
      x: null,
      y: null,
      insertMention: () => {},
      editor: new Editor({
        extensions: [
          new Blockquote(),
          new BulletList(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new HorizontalRule(),
          new ListItem(),
          new OrderedList(),
          new CustomLink(),
          new Bold(),
          new Italic(),
          new Underline(),
          new Code(),
          new History(),
          new Mention({
            // a list of all suggested items
            items: () => {
              return this.taskDetails && this.taskDetails.members;
            },
            // is called when a suggestion starts
            onEnter: ({ items, query, range, command, event }) => {
              this.query = query;
              this.members = items;
              this.suggestionRange = range;
              this.openMentionMenu = true;
              this.insertMention = command;
            },
            // is called when a suggestion has changed
            onChange: ({ items, query, range }) => {
              this.query = query;
              this.suggestionRange = range;
              this.range = range;
              this.members = items;
            },
            onFilter: async (items, query) => {
              this.openMentionMenu = true;
              if (!query) {
                return items;
              }
              await new Promise((resolve) => {
                setTimeout(resolve, 0);
              });
              const fuse = new Fuse(items, {
                threshold: 0.2,
              });
              // this.members = fuse.search(query.toLowerCase()).map((item) => item.item)
              this.members = fuse._docs.filter((user) => {
                return user.name
                  ? user.name.toLowerCase().includes(query.toLowerCase())
                  : false;
              });
              return this.members;
            },
            onExit: () => {
              // reset all saved values
              this.suggestionRange = null;
              this.query = null;
              this.openMentionMenu = false;
              this.members = [];
            },
          }),
          new Placeholder({
            emptyEditorClass: "is-editor-empty",
            emptyNodeClass: "is-empty",
            emptyNodeText: "Write a Comment Here.... ",
            showOnlyWhenEditable: false,
            showOnlyCurrent: true,
          }),

          new SendMessage({
            /*
            For sending message typed in input
            */
            sendMessage: () => this.sendTextMessage(),
          }),
        ],
        onUpdate: ({ getJSON }) => {
          if (!("content" in getJSON().content[0])) {
            this.showMenuBar = false;
          } else {
            this.showMenuBar = true;
          }
        },
        editorProps: {
          handleKeyDown: (view, event) => {
            if (this.members && this.members.length && event.key == "ArrowUp") {
              event.preventDefault();
              if (this.focusMember > 0) {
                this.focusMember--;
                this.mentionMembersScroll();
              }
            } else if (
              this.members &&
              this.members.length &&
              event.key == "ArrowDown"
            ) {
              if (this.focusMember < this.members.length - 1) {
                this.focusMember++;
                this.mentionMembersScroll();
              }
            }
          },
        },
        autoFocus: true,
        disableInputRules: ["italic"],
        disablePasteRules: ["italic"],
      }),
    };
  },
  computed: {
    ...mapGetters(["getScreenRecorderState", "getSelectedCompany"]),
    hasResults() {
      return this.members && this.members.length;
    },
  },

  methods: {
    dispayErrorMessage() {
      let dialogData = {
        title: "Sorry for Inconvenience",
        icon: "warning",
        showCancelButton: true,
        reverseButtons: true,
      };
      if (
        this.getSelectedCompany.role == "admin" ||
        this.getSelectedCompany.role == "owner"
      ) {
        dialogData["html"] = "Please upgrade your plan to use this feature ";
        dialogData["cancelButtonText"] = "Cancel";
        dialogData["confirmButtonText"] = "Update";
      } else {
        dialogData["html"] =
          "Sorry you can't use this feature please contact your company admin";
        dialogData["cancelButtonText"] = "Ok";
        dialogData["showConfirmButton"] = false;
      }
      Swal.fire(dialogData).then((result) => {
        if (result.value) {
          this.$router.push({ name: "billing" });
        }
      });
    },
    async selectUser(id, user) {
      await this.insertMention({
        range: this.suggestionRange,
        attrs: {
          id: id,
          label: user + " ",
        },
      });
      this.query = null;
      this.editor.focus();
      this.openMentionMenu = false;
    },
    mentionMembersScroll() {
      this.$refs &&
        this.$refs.searchFocus &&
        this.$refs.searchFocus[this.focusMember] &&
        this.$refs.searchFocus[this.focusMember].$el &&
        this.$refs.searchFocus[this.focusMember].$el.scrollIntoView({
          block: "end",
        });
    },
    sendTextMessage() {
      this.showMenuBar = false;
      this.openMentionMenu
        ? this.hasResults != 0
          ? (this.selectUser(
              this.members[this.focusMember].id,
              this.members[this.focusMember].name
                ? this.members[this.focusMember].name
                : this.members[this.focusMember].email
            ),
            (this.openMentionMenu = false))
          : eventBus.$emit("sendTextMessage", this.editor.getHTML())
        : eventBus.$emit("sendTextMessage", this.editor.getHTML());
    },
    openScheduleMessageDialog() {
      eventBus.$emit("sendScheduleMessage", true);
    },
  },
  mounted() {
    eventBus.$on("clearTextField", () => {
      this.editor.clearContent();
    });
    eventBus.$on("disableTextField", () => {
      this.editor.setOptions({ editable: false });
    });
    eventBus.$on("editableTextField", () => {
      this.editor.setOptions({ editable: true });
    });
    eventBus.$on("focusTextField", () => {
      this.editor.focus();
    });
    eventBus.$on("scheduleMessage", (data) => {
      eventBus.$emit("scheduleTime", data);
      this.sendTextMessage();
    });
  },
  watch: {
    query() {
      this.focusMember = 0;
    },
    showMenuBar(value) {
      eventBus.$emit("showMenuBar", value);
    },
    displayMenuBar(value) {
      this.showMenuBar = value;
    },
  },
  beforeDestroy() {
    this.editor.destroy();
    eventBus.$off("clearTextField");
    eventBus.$off("focusTextField");
    eventBus.$off("editableTextField");
    eventBus.$off("disableTextField");
  },
};
</script>
<style>
/* Overwriting built in class css from tiptap */
/* Placeholder Design of Message Editor */
.editor p.is-empty:first-child::before {
  content: attr(data-empty-text);
  float: left;
  pointer-events: none;
  color: #757096;
  height: 0;
}
.text-message pre code,
.editor__content pre code {
  display: block;
  background: #f8f8f8 !important;
}

.text-message pre,
.editor__content pre {
  border-radius: 5px;
  font-size: 1rem;
  overflow-x: auto;
  white-space: pre-wrap;
  background: rgb(248, 248, 248) !important;
  border: solid 1px lightgray;
}

/* Editor List BgColor */
.menubar {
  background: #f5f7fb !important;
}
.editor {
  word-wrap: break-word;
  hyphens: auto;
}
.ProseMirror {
  min-height: 35px;
  max-height: 150px;
  overflow: scroll;
  cursor: auto;
}
.menubar .is-active {
  background-color: #e2e1e1;
}
.menubar .v-btn--round {
  border-radius: 5%;
}
.ProseMirror:focus {
  outline: none;
}
.v-application p {
  margin-bottom: 0px;
}

.ProseMirror p {
  cursor: auto !important;
  margin-top: 3px !important;
}
.mentionSuggestion {
  z-index: 9999;
}
/* ------------------ */
</style>
<style scoped>
.mention-users {
  position: absolute;
  bottom: 88px;
  width: 94%;
}
.theme--light.v-list-item--active:before,
.theme--light.v-list-item--active:hover:before,
.theme--light.v-list-item:focus:before {
  opacity: 0 !important;
}
</style>
